import EditIcon from 'components/ReusableComponents/Icons/Edit'
import EyeIcon from 'components/ReusableComponents/Icons/Eye'
import TrashIcon from 'components/ReusableComponents/Icons/Trash'
import InviteEmailDesignCardIconButton from 'features/InviteEmailDesign/InviteEmailDesignCardIconButton'
import { buildInviteEmailDesignEditPath } from 'features/InviteEmailDesign/inviteEmailDesignTemplateHelpers'
import InviteEmailDesignTemplatePreview from 'features/InviteEmailDesign/InviteEmailDesignTemplatePreview'
import InviteEmailDesignUpdatedTooltip from 'features/InviteEmailDesign/InviteEmailDesignUpdatedTooltip'
import { useInviteEmailDesignPreview } from 'features/InviteEmailDesign/useInviteEmailDesignPreview'
import { Link } from 'react-router-dom'

import styles from './InviteEmailDesign.module.scss'

const InviteEmailDesignTemplateCard = ({ template, onPreview, onDelete }) => {
  const editPath = buildInviteEmailDesignEditPath(template.id)
  const { previewHtml, layoutLabel, isLoading, hasError } = useInviteEmailDesignPreview(
    template.id
  )

  return (
    <article
      className={[styles.templateCard, template.isActive ? styles.templateCardActive : '']
        .filter(Boolean)
        .join(' ')}
    >
      <Link
        className={styles.templateCardLink}
        to={editPath}
        aria-label={`Edit ${template.name}`}
      >
        <div className={styles.templateCardMedia}>
          <InviteEmailDesignTemplatePreview
            variant="card"
            previewHtml={previewHtml}
            isLoading={isLoading}
            hasError={hasError}
          />
        </div>

        <div className={styles.templateCardBody}>
          <div className={styles.templateCardHeader}>
            <span className={styles.templateCardName}>{template.name}</span>
            {template.isActive && <span className={styles.activeBadge}>Active</span>}
          </div>
          <span className={styles.templateMeta}>
            Layout: {layoutLabel || template.layoutLabel || 'Default layout'}
          </span>

          <div className={styles.templateUsage}>
            <span className={styles.templateUsageItem}>
              <strong>{template.campaignCount}</strong>
              <span>Campaigns</span>
            </span>
            <span className={styles.templateUsageItem}>
              <strong>
                <i className={styles.activeCampaignDot} aria-hidden="true" />
                {template.activeCampaignCount}
              </strong>
              <span>Active</span>
            </span>
            <span className={styles.templateUpdated}>
              <span>Updated</span>
              <InviteEmailDesignUpdatedTooltip template={template} />
            </span>
          </div>
        </div>
      </Link>

      <div className={styles.templateCardFooter}>
        <Link className={styles.editTemplateButton} to={editPath}>
          <EditIcon width={14} height={14} fill="currentColor" />
          Edit template
        </Link>
        <div className={styles.templateCardActions}>
          <InviteEmailDesignCardIconButton
            label="Preview"
            onClick={event => {
              event.preventDefault()
              event.stopPropagation()
              onPreview(template)
            }}
          >
            <EyeIcon width={18} height={18} fill="currentColor" />
          </InviteEmailDesignCardIconButton>
          <InviteEmailDesignCardIconButton
            label={template.isActive ? 'The active template cannot be deleted' : 'Delete'}
            variant="danger"
            disabled={template.isActive}
            onClick={event => {
              event.preventDefault()
              event.stopPropagation()
              onDelete(template)
            }}
          >
            <TrashIcon width={18} height={18} fill="currentColor" />
          </InviteEmailDesignCardIconButton>
        </div>
      </div>
    </article>
  )
}

export default InviteEmailDesignTemplateCard
